import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
  controller: {
    display: 'none',
    '&[data-display=true]': {
      display: 'block',
    },
  },
}))
